

import axiosInstance from "../axiosInstance";
import { showToast } from "../../utils/toast";

interface AcceptInvitePayload {
  inviteEmail: string;
  inviteToken: string;
}

export const acceptInviteApi = async ({inviteEmail,inviteToken}:AcceptInvitePayload) => {
 
  try {
    const { data } = await axiosInstance.post(`/organisation/join/${inviteToken}/setup`,{email:inviteEmail});

    return data;
  } catch (error: any) {
    if (
      !error.response ||
      error.code === "ECONNABORTED" ||
      error.message?.includes("timeout")
    ) {
      // Network / timeout / offline
      showToast.error("Network error. Please try again.");
    }
    throw error;
  }
};